import { memo, useCallback } from 'react';

import { SOFQuestionInputProps } from './SOFQuestionInput.types';
import { Box, Icon, Input, Text } from '@betty/moonlight';
import { leadingZeroNumberRegex } from '../SOF.constants';

function SOFQuestionInput({
  questionId,
  controlId,
  labelNS,
  labelKey,
  value,
  inputType,
  keyboardType = 'default',
  inputSubType,
  error,
  onChange,
  inputRef,
  onSubmitEditing,
}: SOFQuestionInputProps) {
  const handleChange = useCallback(
    (text: string) => {
      if (keyboardType === 'numeric' && leadingZeroNumberRegex.test(text)) {
        return;
      }
      onChange(questionId, controlId, text, inputType, inputSubType);
    },
    [keyboardType, onChange, questionId, controlId, inputType, inputSubType],
  );

  return (
    <Box marginBottom="space-200">
      <Input
        keyboardType={keyboardType}
        placeholderNS={labelNS}
        placeholderKey={labelKey}
        value={value}
        error={error}
        onChangeText={handleChange}
        ref={inputRef}
        enterKeyHint="next"
        onSubmitEditing={onSubmitEditing}
      />
      {error ? (
        <Box flexDirection="row" alignItems="center" marginTop="space-100">
          <Icon
            name="errorOutline"
            color="darkSurfaceError"
            width={20}
            height={20}
          />
          <Text variant="caption" color="darkSurfaceError">
            {error}
          </Text>
        </Box>
      ) : null}
    </Box>
  );
}

export default memo(SOFQuestionInput);
